import axios from "../request";

//获取
export function GetReceivable(data) {
  return axios.request({
    url: "api/Statistics/GetReceivable",
    method: "get",
    params: data,
  });
}